import axiosInstance from "../../utils/axiosCompany";

export const LoginService = async (values) => {    
    return await axiosInstance().post("company/login", values);
}

export const LoginOtpverification = async (values) => {
    return await axiosInstance().post("company/verifyotp", values);
}

export const ResendotpVerification = async (values) => {
    return await axiosInstance().post("company/resendotp", values)
}

export const Getforgetpassword = async (values) => {
    return await axiosInstance().post("company/forgetpassword", values)
}

export const GetResetpassword = async (values) => {
    return await axiosInstance().post("company/resetpassword", values)
}

